import {
  Box,
  IconButton,
  SnackbarCloseReason,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import {ReactComponent as BackgroundImage} from '../../assests/svg/single-client-header-bg.svg';
import {ReactComponent as SearchIcon} from '../../assests/svg/search_filter.svg';
import AurSvgIcon from '../common/aur-svg-icon/AurSvgIcon';
import {t} from 'i18next';
import AurBreadcrumb from '../common/aur-breadcrumb/AurBreadCrumb';
import KpiPanel from './welcome-screen-single-client/KpiPanel';
import {ReactComponent as PlusIcon} from '../../assests/svg/plus-icon.svg';
import {useEffect, useRef, useState} from 'react';
import {Project} from './welcome-screen-single-client/model';
import ProjectListItem from './welcome-screen-single-client/ProjectListItem';
import {SingleClientTabStatus} from './user-management/models';
import AurPopup from '../common/aur-popup/AurPopup';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import {
  BUDGET_AlERT_COUNT_UPTO_ONE,
  DEFAULT_PROJECT_COUNTRY_CODE,
  CUSTOM_REPORT_COL_HEIGHT,
  INVOICE_REPORT_GRID_ERROR_COMPONENT,
  MIN_SEARCH_CHAR,
  MIN_SEARCH_CHAR_FOR_ENTER,
  ONLY_DATE_SHOW_FORMAT,
  TABLE_PER_PAGE_DEFAULT_NO_ROW,
  CLIENT_PERMISSION_CODES_CONSTANTS,
  MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS,
  PERMISSION_TYPE,
} from '../../constants/constants';
import {RootState} from '../../redux/store';
import {useDispatch, useSelector} from 'react-redux';
import {
  getCustomReportsAlert,
  getProjectsMe,
  updateAlertStatusAsViewed,
} from '../../api/UserManagementService';
import {selectUser} from '../../redux/slices/userSlice';
import {
  clearFilters,
  downloadProjectsDetailsExportXlsx,
  getPermissionsbyClientId,
  getSavedFilters,
  saveFilters,
} from '../../api/ClientManagementService';
import {
  downloadResponseAsXLSX,
  formatNumberWithComma,
  getFilenameFromHeaders,
  getHostCountryCode,
  getUTCDateTimeForDisplay,
  IArrayData,
  manipulateProjectCountryCode,
  removeEmptyArrays,
  scrollToGridView,
} from '../../utils/utils';

import AurChipList, {AurChipConfig} from '../common/aur-chip/AurChipList';

import {setHasFilterValueChanged} from '../../redux/slices/intakeAuditTabSlice';
import AurSelectDropdown from '../common/aur-select-dropdown/AurSelectDropdown';
import {getClientOverView} from '../../api/ReportingManagement';
import AurSearchBox from '../common/aur-search-box/AurSearchBox';
import AurAlertCarousel from '../common/aur-alert/AurAlertCarousel';
import {CustomAlert} from '../../redux/slices/alertSlice';
import AurLoadingIndicator from '../common/aur-loading-indicator/AurLoadingIndictor';
import {setSelectedClientId} from '../../redux/slices/clientListSlice';
import {Permission} from '../../types/types';
import {showErrorToast} from '../../api/utils';
import {useToast} from '../../contexts/toastContext/ToastContext';
import AurDataGridErrorOverlay from '../common/aur-data-grid-error-overlay/AurDataGridErrorOverlay';
import {setModalDropDownSelectedItem} from '../../redux/slices/invoiceModalSlice';
import AurTooltip from '../common/aur-tooltip/AurTooltip';
import AurPagination from '../common/aur-pagination/AurPagination';
import {setOverviewDataset} from '../../redux/slices/reportsSlice';
import BudgetTrackerOverview from '../budget-tracker/BudgetTrackerOverview';
import {
  setBudgetAlertCount,
  setBudgetAlertId,
  setShowBudgetTrackerAlertModal,
  setShowBudgetTrackerDeleteToast,
  setShowBudgetTrackerModal,
  setViewProjectName,
} from '../../redux/slices/budgetTrackerSlice';
import BudgetTrackerAlertModal from '../budget-tracker/BudgetTrackerAlertList';
import AurToast from '../common/aur-toast/AurToast';
import {
  setFilterState,
  setTabLabelState,
  setItemsPerPageState,
  setCurrentPageState,
  setStartScroll,
  setSelectedProjectId,
  setSelectedWorkspaceId,
  setSelectedClientIdState,
  resetProjectOverviewState,
} from '../../redux/slices/projectOverviewSlice';
import _ from 'lodash';
import AurButton from '../common/aur-button/AurButton';
import navConstants from '../../constants/navConstants';
import {
  PROJECT_CREATION_PATH,
  setClientIdForProjectCreation,
  setProjectCreationInitiatedFrom,
  storeSelectedAgreement,
} from '../../redux/slices/projectCreationSlice';
import {hasAdminAccess} from '../../utils/authorization';
import {getUserRoleForGA} from '../../utils/analyticsUtils';
import {setUserRole} from '../../redux/slices/analyticsSlice';
import {AurLightTooltip} from '../common/aur-light-tooltip/aur-light-tooltip';
import AurManageClientDropdown from '../common/aur-manage-client-dropdown/AurManageClientDropdown';

export interface IFiltersData {
  branches?: string[];
  departments?: string[];
  entities: string[];
  search: string;
}
interface Alerts {
  userAlertId: number;
  triggeredOn: string;
  alertTitle: string;
  alertDescription: string;
  alertType: string;
  alertLevel: string;
  clientId: string;
  projectId: string;
  projectName: string;
  reportType: string;
}

type ProjectOverviewFilterOptions = {
  branches: {id: string; name: string}[];
  departments: {id: string; name: string}[];
  entities: {id: string; name: string}[];
};
const defaultProjectOverviewFilterOptions: ProjectOverviewFilterOptions = {
  branches: [],
  departments: [],
  entities: [],
};

// memberStats interface
interface MemberStats {
  total: number;
  active: number;
  closed: number;
}
const defaultMemberStats: MemberStats = {
  total: 0,
  active: 0,
  closed: 0,
};
export interface IDataSet {
  datasetsProcessed: number;
  metricsUpdatedOn: string;
  projectsAdded: number;
  productionCompleted: number;
  recentDays: number;
}

const DEFAULT_PAGE_Number = 1;
const DEFAULT_TOTAL_ITEMS = 0;
const MIN_ITEMS_HIDE_PAGINATION = 25;
const SCROLL_DELAY = 1500; // mili second

const WelcomeScreenSingleClient = ({userKind}: {userKind: number}) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const pageHistory = useSelector(
    (state: RootState) => state.pageHistory.history
  );
  const [projectDataFetchAllowed, setProjectDataFetchAllowed] = useState(false);
  const [isDownloadingCsv, setIsDownloadingCsv] = useState<boolean>(false);
  const [projectLoaded, setProjectLoaded] = useState(false);
  const [overviewLoaded, setOverviewLoaded] = useState(false);
  const [viewedClientIds, setViewedClientIds] = useState<string[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [value, setValue] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [projects, setProjects] = useState<Project[]>([]);
  const [drpBranch, setDrpBranch] = useState([]);
  const [drpDepartment, setDrpDepartment] = useState([]);
  const [dataSet, setDataSet] = useState<IDataSet | null>(null);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [drpEntity, setDrpEntity] = useState([]);
  const [tabLabel, setTabLabel] = useState(SingleClientTabStatus.all);
  const [memberStats, setMemberStats] =
    useState<MemberStats>(defaultMemberStats);

  const [permissionData, setPermissionData] = useState<Permission[]>([]);
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const [expandedProjectId, setExpandedProjectId] = useState<string | null>(
    null
  );
  const [savedFilterFetched, setSavedFilterFetched] = useState<boolean>(false);
  const {showToast} = useToast();
  const selectedClient = useSelector(
    (state: RootState) => state.selectedClient
  );
  const showBudgetTrackeDeleteToast = useSelector(
    (state: RootState) => state.budgetTrackerModal
  ).showBudgetTrackerDeleteToast;
  const showBudgetTrackerModal = useSelector(
    (state: RootState) => state.budgetTrackerModal
  ).showBudgetTrackerModal;

  const viewProjectPageInfo = useSelector(
    (state: RootState) => state.budgetTrackerModal
  ).viewProjectPageInfo;
  const [isGetProjectsLoading, setIsGetProjectsLoading] = useState(false);
  const [isOnSaveFilterLoading, setIsOnSaveFilterLoading] = useState(false);
  const [isClearAllFilterLoading, setIsClearAllFilterLoading] = useState(false);
  const [mergedAlertData, setMergedAlertData] = useState<any[]>([]);
  const [hostCountryCode, setHostCountryCode] = useState<string>('');
  const [isFailedToLoadContent] = useState<boolean>(false);
  const showBudgetTrackerAlertModal = useSelector(
    (state: RootState) => state.budgetTrackerModal
  ).showBudgetTrackerAlertModal;

  const tableContainerRef = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState(
    (tableContainerRef.current?.offsetHeight ?? 500) +
      INVOICE_REPORT_GRID_ERROR_COMPONENT
  );
  const [itemsPerPage, setItemsPerPage] = useState<number>(
    TABLE_PER_PAGE_DEFAULT_NO_ROW
  );

  const [currentPage, setCurrentPage] = useState<number>(DEFAULT_PAGE_Number);
  const [totalItems, setTotalItems] = useState<number>(DEFAULT_TOTAL_ITEMS);
  const [hasProjectSettingsPermission, setHasProjectSettingsPermission] =
    useState<boolean>(false);

  const [hasCreateProjectsPermission, setHasCreateProjectsPermission] =
    useState<boolean>(false);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    dispatch(setViewProjectName(''));
  };
  const [projectOverviewFilterOptions, setProjectOverviewFilterOptions] =
    useState<ProjectOverviewFilterOptions>(defaultProjectOverviewFilterOptions);

  useEffect(() => {
    const storedClientIds = sessionStorage.getItem('viewedClientIds');
    if (storedClientIds) {
      setViewedClientIds(JSON.parse(storedClientIds));
    }
  }, []);

  useEffect(() => {
    if (viewedClientIds.length > 0) {
      sessionStorage.setItem(
        'viewedClientIds',
        JSON.stringify(viewedClientIds)
      );
    }
  }, [viewedClientIds]);

  const [
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    projectOverviewSelectedFilterOptions,
    setProjectOverviewSelectedFilterOptions,
  ] = useState<ProjectOverviewFilterOptions>(
    defaultProjectOverviewFilterOptions
  );
  const [loadingAlert, setLoadingAlert] = useState<boolean>(false);
  const isProjectLoading = useRef(false);
  const projectCountSerachParam = useRef('');
  const projectSearchParam = useRef('');
  const projectRequestBody = useRef('');
  const [showMetricsTileSection, setShowMetricsTileSection] =
    useState<boolean>(false);

  useEffect(() => {
    setHostCountryCode(getHostCountryCode());
  }, []);

  // Filter start
  const projectOverviewState = useSelector(
    (state: RootState) => state.projectOverview
  );

  const createChipConfigData = (data?: IFiltersData) => {
    const mapSelections = (items: any, selectedIds: any) =>
      items
        .filter((item: any) => selectedIds?.includes(item.id))
        .map((item: any) => ({id: item.id, value: item.name}));

    return [
      {
        id: 1,
        filterName: t('filter.filterBranch'),
        filterSelection: data?.branches?.length
          ? mapSelections(drpBranch, data.branches)
          : [],
        showRemove: true,
        onRemove: () => onRemoveFilter(1),
      },
      {
        id: 2,
        filterName: t('filter.department'),
        filterSelection: data?.departments?.length
          ? mapSelections(drpDepartment, data.departments)
          : [],
        showRemove: true,
        onRemove: () => onRemoveFilter(2),
      },
      {
        id: 3,
        filterName: t('filter.filterEntity'),
        filterSelection: data?.entities?.length
          ? mapSelections(drpEntity, data.entities)
          : [],
        showRemove: true,
        onRemove: () => onRemoveFilter(3),
      },
      {
        id: 4,
        icon: <SearchIcon />,
        filterName: t('filter.search'),
        filterSelection: data?.search
          ? [
              {
                id: 1,
                value: data.search,
              },
            ]
          : [],
        showRemove: true,
        onRemove: () => onRemoveFilter(4),
      },
    ];
  };

  // using these values for now to fetch the data from API
  const {clientId} = useSelector((state: RootState) => state.reports);

  const [chipConfigs, setChipConfigs] = useState<AurChipConfig[]>(
    createChipConfigData()
  );

  const isFetchingRef = useRef(false);

  useEffect(() => {
    if (selectedClient.clientId !== '' && !isFetchingRef.current) {
      if (!savedFilterFetched) {
        if (
          drpBranch.length > 0 &&
          drpDepartment.length > 0 &&
          drpEntity.length > 0
        ) {
          fetchSavedFilters();
        }
      }
    }
  }, [drpBranch, drpDepartment, drpEntity]);

  const handleItemsPerPageChange = (itemPerPage: number) => {
    setItemsPerPage(itemPerPage);
    setCurrentPage(1);
    dispatch(setViewProjectName(''));
  };

  useEffect(() => {
    const updateHeight = () => {
      if (tableContainerRef.current) {
        setSize(
          tableContainerRef.current.offsetHeight - CUSTOM_REPORT_COL_HEIGHT
        );
      }
    };
    window.addEventListener('resize', updateHeight);
    updateHeight();

    return () => window.removeEventListener('resize', updateHeight);
  });

  const fetchClientOverview = async () => {
    try {
      const response = await getClientOverView(selectedClient.clientId);
      const res = await response?.data;
      setDataSet(res?.data);
      dispatch(setOverviewDataset(res?.data ?? null));
      setOverviewLoaded(true);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPermissions = async () => {
    try {
      const response = await getPermissionsbyClientId(selectedClient.clientId);
      const permissions = (response?.data?.data?.value?.permissions ||
        []) as Permission[];
      const projectPermissions = (response?.data?.data?.value
        ?.projectPermissions || []) as Permission[];

      const manageProjectPermissions = permissions.filter(
        (item) => item?.type === PERMISSION_TYPE.MANAGE_PROJECT
      );
      const projectManageProjectPermissions = projectPermissions.filter(
        (item) => item?.type === PERMISSION_TYPE.MANAGE_PROJECT
      );

      const userRoles = response?.data?.data?.value?.userRole || [];

      const gaRole = await getUserRoleForGA(userRoles);
      dispatch(setUserRole(gaRole));
      const isAdmin = await hasAdminAccess(userRoles, selectedClient.clientId);

      setPermissionData(permissions);

      const hasProjectSettingsPermission =
        manageProjectPermissions.some(
          (item) =>
            item.type === PERMISSION_TYPE.MANAGE_PROJECT &&
            item.permissionCode ===
              MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS.MANAGE_PROJECT_SETTINGS
        ) ||
        projectManageProjectPermissions.some(
          (item) =>
            item.type === PERMISSION_TYPE.MANAGE_PROJECT &&
            item.permissionCode ===
              MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS.MANAGE_PROJECT_SETTINGS
        );
      setHasProjectSettingsPermission(hasProjectSettingsPermission);

      const hasCreateProjectPermission = manageProjectPermissions.some(
        (item) =>
          item.type === PERMISSION_TYPE.MANAGE_PROJECT &&
          item.permissionCode ===
            MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS.CREATE_NEW_PROJECT
      );
      setHasCreateProjectsPermission(hasCreateProjectPermission);
      setShowMetricsTileSection(isAdmin);
    } catch (error) {
      showErrorToast(showToast, null);
      console.error(error);
    }
  };

  useEffect(() => {
    setItemsPerPage(TABLE_PER_PAGE_DEFAULT_NO_ROW);
    setCurrentPage(DEFAULT_PAGE_Number);
    setTotalItems(DEFAULT_TOTAL_ITEMS);
    resetProjectOverviewState();
    setProjects([]);
    fetchPermissions();
    fetchClientOverview();
    dispatch(setSelectedClientId(selectedClient.clientId));
  }, [selectedClient.clientId]);

  useEffect(() => {
    const hasViewPermission = permissionData.some(
      (i) =>
        i?.permissionCode == CLIENT_PERMISSION_CODES_CONSTANTS.CLIENTS_VIEW ||
        i?.permissionCode ==
          CLIENT_PERMISSION_CODES_CONSTANTS.MANAGE_PERMISSION_GROUPS
    );
    setIsMenuVisible(hasViewPermission || hasProjectSettingsPermission);
  }, [permissionData, hasProjectSettingsPermission]);

  const user = useSelector(selectUser);

  const fetchOverviewProjects = async (param: string) => {
    try {
      isProjectLoading.current = true;
      setIsGetProjectsLoading(true);
      storeFilterState();
      const requestBody = getSelectedFilters();
      const response = await getProjectsMe(
        selectedClient.clientId,
        requestBody,
        param
      );
      setProjects(response?.data?.data?.projects ?? []);

      const countData = response?.data?.data?.countData;

      if (countData) {
        setMemberStats({
          total: countData?.all,
          active: countData?.active,
          closed: countData?.closed,
        });
      } else {
        setMemberStats(defaultMemberStats);
      }

      const filterData = response?.data?.data?.filterData;

      setProjectOverviewFilterOptions(
        filterData ?? defaultProjectOverviewFilterOptions
      );
      if (filterData) {
        setDrpBranch(filterData?.branches);
        setDrpDepartment(filterData?.departments);
        setDrpEntity(filterData?.entities);
      }

      setIsGetProjectsLoading(false);
      isProjectLoading.current = false;
      setProjectLoaded(true);
      setTimeout(() => {
        scrollToGridView('#project-list-container');
      }, 300);
    } catch (error) {
      showErrorToast(showToast, error, 'center');
      setMemberStats(defaultMemberStats);
      setProjectOverviewFilterOptions(defaultProjectOverviewFilterOptions);
      setIsGetProjectsLoading(false);
      isProjectLoading.current = false;
    }
  };

  const handleCreateNewProject = () => {
    dispatch(
      setProjectCreationInitiatedFrom(PROJECT_CREATION_PATH.ClientOverview)
    );
    dispatch(storeSelectedAgreement(undefined));
    dispatch(setClientIdForProjectCreation(clientId))
    navigate(navConstants.projectCreation.serviceAgreement);
  };

  useEffect(() => {
    projectSearchParam.current = '';
    projectCountSerachParam.current = '';
    projectRequestBody.current = '';

    setProjectOverviewSelectedFilterOptions(
      defaultProjectOverviewFilterOptions
    );
    setChipConfigs(createChipConfigData());
    setSearchKeyword('');
    setSavedFilterFetched(false);
  }, [clientId]);

  useEffect(() => {
    switch (tabLabel) {
      case SingleClientTabStatus.active:
        setTotalItems(memberStats.active);
        break;
      case SingleClientTabStatus.closed:
        setTotalItems(memberStats.closed);
        break;
      default:
        setTotalItems(memberStats.total);
        break;
    }
  }, [tabLabel, clientId, memberStats]);

  useEffect(() => {
    const requestBody = JSON.stringify(getSelectedFilters());

    if (!isProjectLoading.current && projectDataFetchAllowed) {
      const param =
        `status=${tabLabel == SingleClientTabStatus.all ? '' : tabLabel}` +
        `&pageSize=${itemsPerPage}&pageNumber=${currentPage}&SearchTerm=${searchKeyword}`;
      if (
        projectSearchParam.current != param ||
        projectRequestBody.current != requestBody
      ) {
        projectSearchParam.current = param;
        fetchOverviewProjects(param);
      }
    }
    projectRequestBody.current = requestBody;
  }, [searchKeyword, chipConfigs, projectDataFetchAllowed]);

  useEffect(() => {
    if (!isProjectLoading.current && projectDataFetchAllowed) {
      const param =
        `status=${tabLabel == SingleClientTabStatus.all ? '' : tabLabel}` +
        `&pageSize=${itemsPerPage}&pageNumber=${currentPage}&SearchTerm=${searchKeyword}`;
      projectSearchParam.current = param;
      fetchOverviewProjects(param);
    }
  }, [tabLabel, currentPage, itemsPerPage, projectDataFetchAllowed]);

  const refreshOverviewProjects = () => {
    const param =
      `status=${tabLabel == SingleClientTabStatus.all ? '' : tabLabel}` +
      `&pageSize=${itemsPerPage}&pageNumber=${currentPage}&SearchTerm=${searchKeyword}`;
    fetchOverviewProjects(param);
  };

  const hasChipSelections =
    chipConfigs[0]?.filterSelection?.length > 0 ||
    chipConfigs[1]?.filterSelection?.length > 0 ||
    chipConfigs[2]?.filterSelection?.length > 0 ||
    chipConfigs[3]?.filterSelection?.length > 0;

  const breadCrumbItems = [
    {
      label: t('welcomeScreenSingleClient.home'),
      path: '/welcome-multi-client',
    },
    {
      label: t('welcomeScreenSingleClient.projectOverview'),
    },
  ];

  /*
    Function to generate accessibility properties for tab elements
  */
  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    tabIndex: 0,
  });

  /*
    Handler for updating the current value based on a new tab selection
  */
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setItemsPerPage(TABLE_PER_PAGE_DEFAULT_NO_ROW);
    setCurrentPage(DEFAULT_PAGE_Number);
    setTotalItems(DEFAULT_TOTAL_ITEMS);
    switch (newValue) {
      case 0:
        setTabLabel(SingleClientTabStatus.all);
        break;
      case 1:
        setTabLabel(SingleClientTabStatus.active);
        break;
      case 2:
        setTabLabel(SingleClientTabStatus.closed);
        break;
      default:
        setTabLabel(SingleClientTabStatus.all);
        break;
    }
    setValue(newValue);
  };

  const handleDrawer = () => {
    setShowDrawer(true);
  };

  const tooltipClasses = {
    arrow: 'aur-leftnav_tooltip-arrow',
    tooltip: 'aur-leftnav_tooltip-tooltip',
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (clientId) {
      fetchCustomAlert();
    }
    dispatch(setViewProjectName(''));
  }, [clientId]);

  const fetchSavedFilters = async () => {
    setSavedFilterFetched(true);
    try {
      dispatch(setHasFilterValueChanged(false));
      if (clientId) {
        const paramString = buildParamString({
          clientId,
        });
        const result = await getSavedFilters(paramString);
        if (result?.data?.data) {
          setFiltersAndChipData(result.data.data[0]);
          if (result?.data?.data[0]?.search) {
            setSearchKeyword(result?.data?.data[0]?.search || '');
          }
        }
      }
    } catch (error: any) {
      if ((error && error.status === 400) || error.status === 404) {
        console.error(error);
      }
    }
  };

  const buildParamString = ({clientId}: any) => {
    return `${clientId}`;
  };

  const hasFilterValueChanged = useSelector(
    (state: RootState) => state.intakeAuditTab.hasFilterValueChanged
  );

  const setFiltersAndChipData = (data: IFiltersData) => {
    setChipConfigs(createChipConfigData(data));
  };

  const [clearAllModal, setClearAllModal] = useState<boolean>(false);
  const [resetToDefaultModal, setResetToDefaultModal] =
    useState<boolean>(false);

  const [budgetDataLength, setBudgetDataLength] = useState<number>(0);
  const [openToast, setOpenToast] = useState<boolean>(false);

  const onRemoveFilter = (filterId: number) => {
    dispatch(setHasFilterValueChanged(true));
    switch (filterId) {
      case 1:
        setProjectOverviewSelectedFilterOptions((prev) => {
          return {...prev, branches: []};
        });
        break;
      case 2:
        setProjectOverviewSelectedFilterOptions((prev) => {
          return {...prev, departments: []};
        });
        break;
      case 3:
        setProjectOverviewSelectedFilterOptions((prev) => {
          return {...prev, entities: []};
        });
        break;
      case 4:
        setSearchKeyword('');
        break;
    }
    setCurrentPage(1);
    setChipConfigs((prevConfig) =>
      prevConfig?.map((filter) =>
        filter.id === filterId ? {...filter, filterSelection: []} : filter
      )
    );
  };

  const handleOnClearAll = () => {
     setClearAllModal(true);
  };
  const handleOnSave = () => {
    onSaveFilters();
  };

  const onSaveFilters = async (resetToDefault = false) => {
    setIsOnSaveFilterLoading(true);
    try {
      const paramString = `${clientId}`;
      const requestBody = getSelectedFilters(resetToDefault);
      const result = await saveFilters(paramString, requestBody);
      const savedFilters =
        result?.data?.data?.result ?? result?.data?.result ?? requestBody;
      setFiltersAndChipData(savedFilters);
      setSearchKeyword(savedFilters?.search || '');
      dispatch(setHasFilterValueChanged(false));
    } catch (error) {
      console.error('Failed to Clear saved filters:', error);
    } finally {
      setIsOnSaveFilterLoading(false);
    }
  };

  // keeping this code for now. We will use this API once backend DELETE API fixes are done
  const onClearFilters = async () => {
    setIsClearAllFilterLoading(true);
    try {
      if (clientId) {
        await clearFilters(clientId);
        handleClearAllModalOptionSelected();
      }
    } catch (error) {
      console.error('Failed to Clear saved filters:', error);
    } finally {
      setIsClearAllFilterLoading(false);
    }
  };

  const handleResetToDefaultModalOptionSelected = () => {
    closeModalHandler();
    onClearFilters();
  };

  const handleResetToDefault = () => {
    setResetToDefaultModal(true);
  };

  const closeModalHandler = () => {
    setClearAllModal(false);
    setResetToDefaultModal(false);
  };

  const handleClearAllModalOptionSelected = () => {
      setProjectOverviewSelectedFilterOptions(
        defaultProjectOverviewFilterOptions
      );
      closeModalHandler();
      setSearchKeyword('');
      setChipConfigs((prevConfig) =>
        prevConfig.map((filter) => ({...filter, filterSelection: []}))
      );
  };

  const getSelectedFilters = (resetToDefault = false) => {
    const result: IArrayData = {
      branches: [],
      departments: [],
      entities: [],
      search: '',
    };
    if (resetToDefault) {
      delete result.branches;
      delete result.departments;
      //delete result.entities
      return result;
    }

    chipConfigs.forEach((chipConfig) => {
      switch (chipConfig.filterName) {
        case 'Branch':
          result.branches = chipConfig.filterSelection.map((item) =>
            item.id.toString()
          );
          break;
        case 'Department':
          result.departments = chipConfig.filterSelection.map((item) =>
            item.id.toString()
          );
          break;
        case 'Entity':
          result.entities = chipConfig.filterSelection.map((item) =>
            item.id.toString()
          );
          break;
        case 'Search':
          {
            const searchString = chipConfig?.filterSelection?.[0]?.value;
            result.search = searchString;
          }
          break;
        default:
          break;
      }
    });
    return removeEmptyArrays(result);
  };
  const handleOnDropdownDataChanged = (id: any, filterData: any) => {
    if (filterData && chipConfigs?.[id]) {
      setChipConfigs((prevChipsConfig) =>
        prevChipsConfig.map((chipConfig, index) =>
          index === id
            ? {...chipConfig, filterSelection: filterData}
            : chipConfig
        )
      );
      setCurrentPage(1);
      dispatch(setHasFilterValueChanged(true));
    }
  };
  const handleOnSearch = (keyword: string) => {
    if (keyword.length >= MIN_SEARCH_CHAR_FOR_ENTER) {
      setSearchKeyword(keyword);
      setCurrentPage(1);
      setChipConfigs((prevConfig) =>
        prevConfig.map((filter) =>
          filter.id === 4
            ? {
                ...filter,
                filterSelection:
                  filter.filterSelection.length > 0
                    ? filter.filterSelection.map((selection) =>
                        selection.id === 1
                          ? {
                              ...selection,
                              value:
                                keyword === selection.value
                                  ? selection.value
                                  : keyword,
                            }
                          : selection
                      )
                    : [
                        {
                          id: 1,
                          value: keyword,
                        },
                      ],
              }
            : filter
        )
      );
      dispatch(setHasFilterValueChanged(true));
    } else {
      setSearchKeyword(keyword);
      setChipConfigs((prevConfig) =>
        prevConfig.map((filter) =>
          filter.id === 4 ? {...filter, filterSelection: []} : filter
        )
      );
    }
  };
  // Filter end

  const handleDownloadProjectDetailsXlsx = () => {
    handleDownloadReportXlsx();
  };

  const handleDownloadReportXlsx = async () => {
    setIsDownloadingCsv(true);
    try {
      const requestBody = getSelectedFilters();
      const response = await downloadProjectsDetailsExportXlsx(
        clientId as string,
        tabLabel == SingleClientTabStatus.all ? '' : tabLabel,
        requestBody
      );
      const fileName =
        getFilenameFromHeaders(response.headers['content-disposition']) ??
        `${clientId}_${Date.now()}`;
      downloadResponseAsXLSX(response, fileName, false);
    } catch (error: any) {
      console.error(error?.message);
    } finally {
      setIsDownloadingCsv(false);
    }
  };

  const markAlertAsViewed = async (userAlertId: number) => {
    try {
      await updateAlertStatusAsViewed(userAlertId);
      fetchCustomAlert();
    } catch (error) {
      console.error('fetch custom alert error:', error);
    }
  };

  const handleCustomRedirection = (alertData: CustomAlert) => {
    if (alertData.alertType != 'BudgetTracker') {
      const projectCode = projects.find(
        (item) => item.projectId === alertData?.projectId
      )?.projectCode;

      dispatch(
        setModalDropDownSelectedItem({
          id: alertData?.projectId ?? '',
          name: alertData?.projectName ?? '',
          code: projectCode,
        })
      );
      navigate('/customreports');
    } else if (budgetDataLength === 1) {
      dispatch(setShowBudgetTrackerModal(true));
      dispatch(
        setModalDropDownSelectedItem({
          id: alertData?.projectId ?? '',
          name: alertData?.projectName ?? '',
        })
      );
      dispatch(setBudgetAlertCount(budgetDataLength));
    } else if (budgetDataLength > 1) {
      dispatch(setShowBudgetTrackerAlertModal(true));
    }
  };

  const onHandleNavigation = (
    budgetDataLength: any,
    projectName: string,
    projectId: string,
    userAlertId: number
  ) => {
    if (budgetDataLength === BUDGET_AlERT_COUNT_UPTO_ONE) {
      dispatch(setShowBudgetTrackerModal(true));
      dispatch(setBudgetAlertCount(budgetDataLength));
      dispatch(setBudgetAlertId(userAlertId));
      dispatch(
        setModalDropDownSelectedItem({
          id: projectId,
          name: projectName,
        })
      );
    } else if (budgetDataLength > BUDGET_AlERT_COUNT_UPTO_ONE) {
      dispatch(setShowBudgetTrackerAlertModal(true));
      dispatch(setBudgetAlertCount(budgetDataLength));
    }
    dispatch(setViewProjectName(''));
  };

  const fetchCustomAlert = async () => {
    setLoadingAlert(true);
    try {
      setMergedAlertData([]);
      const customAlert = await getCustomReportsAlert(clientId!);
      const alertsData = customAlert?.data?.data;
      if (alertsData.length > 0) {
        const customReports = alertsData.filter(
          (alert: Alerts) => alert.alertType !== 'BudgetTracker'
        );
        const BudgetTrackerAlerts = alertsData.filter(
          (alert: Alerts) => alert.alertType === 'BudgetTracker'
        );
        setLoadingAlert(false);
        if (BudgetTrackerAlerts.length > 0) {
          const BudgetTrackerLength = BudgetTrackerAlerts.length;
          setBudgetDataLength(BudgetTrackerLength);
          const latestBudgetAlert = BudgetTrackerAlerts.reduce(
            (latest: Alerts, current: Alerts) => {
              return new Date(current.triggeredOn) >
                new Date(latest.triggeredOn)
                ? current
                : latest;
            }
          );
          const combinedBudgetAlert: Alerts[] = [
            {
              userAlertId: latestBudgetAlert.userAlertId,
              triggeredOn: latestBudgetAlert.triggeredOn,
              alertTitle:
                BudgetTrackerLength > BUDGET_AlERT_COUNT_UPTO_ONE
                  ? t(
                      'ecaHomepageModals.budgetTracker.clientalerts.multiProject'
                    )
                  : t(
                      'ecaHomepageModals.budgetTracker.clientalerts.singleProject'
                    ),
              alertDescription: t(
                'ecaHomepageModals.budgetTracker.clientalerts.alertDesc'
              ),
              alertType: 'BudgetTracker',
              alertLevel: 'Project',
              clientId: latestBudgetAlert.clientId,
              projectId: latestBudgetAlert.projectId,
              projectName: latestBudgetAlert.projectName,
              reportType: 'BudgetTracker',
            },
          ];
          setMergedAlertData([...combinedBudgetAlert, ...customReports]);
        } else {
          setMergedAlertData(customReports);
        }
      }
    } catch (error) {
      console.error('fetch custom alert error:', error);
    } finally {
      setLoadingAlert(false);
    }
  };
  const handleSnackbarClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setShowBudgetTrackerDeleteToast(false));
  };

  useEffect(() => {
    if (showBudgetTrackeDeleteToast) {
      setOpenToast(true);
      setTimeout(() => {
        fetchCustomAlert();
        setOpenToast(true);
      }, 1000);
      setInterval(() => {
        dispatch(setShowBudgetTrackerDeleteToast(false));
        setOpenToast(false);
      }, 5000);
    }
  }, [showBudgetTrackeDeleteToast]);

  const listRefMap = useRef<{[projectName: string]: HTMLDivElement | null}>({});

  const viewProjectName = useSelector(
    (state: RootState) => state.budgetTrackerModal
  ).viewProjectName;

  useEffect(() => {
    if (viewProjectName) {
      const targetElement = listRefMap.current[viewProjectName];
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } else {
        const param =
          `status=${tabLabel == SingleClientTabStatus.all ? '' : tabLabel}` +
          `&pageSize=${viewProjectPageInfo.pageSize}&pageNumber=${viewProjectPageInfo.pageNumber}&SearchTerm=${searchKeyword}`;
        fetchOverviewProjects(param);
        setCurrentPage(viewProjectPageInfo.pageNumber);
        setItemsPerPage(viewProjectPageInfo.pageSize);
        setTimeout(() => {
          const targetElement = listRefMap.current[viewProjectName];
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 1000);
      }
    }
  }, [viewProjectName]);

  // save, restore state and scroll to workspace --- start
  const storeFilterState = () => {
    dispatch(setFilterState(_.cloneDeep(chipConfigs)));
    dispatch(setTabLabelState(tabLabel));
    dispatch(setItemsPerPageState(itemsPerPage));
    dispatch(setCurrentPageState(currentPage));
    dispatch(setSelectedClientIdState(selectedClient.clientId));
  };

  const resetScrollAndExpandState = () => {
    dispatch(setStartScroll(false));
    dispatch(setSelectedProjectId(null));
    dispatch(setSelectedWorkspaceId(null));
  };

  const restorePageState = () => {
    const chipConfigState = (
      projectOverviewState.filterState as AurChipConfig[]
    )?.map((item, index) => {
      const chipData = {
        ...item,
        onRemove: () => onRemoveFilter(index + 1),
      };
      if (index == 3) return {...chipData, icon: <SearchIcon />}; // for search chip
      return chipData;
    });

    setTabLabel(projectOverviewState.tabLabel ?? SingleClientTabStatus.all);
    setItemsPerPage(projectOverviewState.itemsPerPage);
    setCurrentPage(projectOverviewState.currentPage);
    setSearchKeyword(chipConfigState[3]?.filterSelection[0]?.value ?? '');
    setChipConfigs(chipConfigState);

    switch (projectOverviewState.tabLabel) {
      case SingleClientTabStatus.all:
        setValue(0);
        break;
      case SingleClientTabStatus.active:
        setValue(1);
        break;
      case SingleClientTabStatus.closed:
        setValue(2);
        break;
    }
  };

  useEffect(() => {
    if (
      !projectOverviewState.selectedProjectId ||
      projectOverviewState.selectedClientId != selectedClient.clientId
    ) {
      resetScrollAndExpandState();
      setProjectDataFetchAllowed(true);
    }
  }, []);
  useEffect(() => {
    if (
      projectOverviewState.selectedProjectId &&
      projectOverviewState.selectedClientId == selectedClient.clientId &&
      pageHistory.length > 2
    ) {
      const lastVisitedPaths = [...pageHistory].reverse().slice(0, 3);
      if (lastVisitedPaths[0] != location.pathname) return;
      const isCorrectSequence =
        (lastVisitedPaths[0] == lastVisitedPaths[2] &&
          lastVisitedPaths[1] == '/reports') ||
        lastVisitedPaths[1] == '/eci-home-page';
      if (isCorrectSequence) {
        restorePageState();
        setProjectDataFetchAllowed(true);
      } else {
        resetScrollAndExpandState();
        setProjectDataFetchAllowed(true);
      }
    }
  }, [pageHistory]);

  useEffect(() => {
    if (projectLoaded && overviewLoaded) {
      setTimeout(() => {
        dispatch(setStartScroll(true));
      }, SCROLL_DELAY);
    }
  }, [projectLoaded, overviewLoaded]);
  // save, restore state and scroll to workspace --- end

  if (userKind === 1) {
    return <Navigate to="*" />;
  }

  const onExpandProject = (
    domainCountryCode?: string,
    ecaEnabled?: boolean
  ) => {
    if (!ecaEnabled) return;
    const projectCountryCode = manipulateProjectCountryCode(
      hostCountryCode,
      domainCountryCode ? domainCountryCode : DEFAULT_PROJECT_COUNTRY_CODE
    );

    if (hostCountryCode.toLowerCase() !== projectCountryCode.toLowerCase()) {
      if (viewedClientIds.length == 0) {
        setViewedClientIds([...viewedClientIds, selectedClient.clientId]);
      } else {
        if (!viewedClientIds.find((x) => x == selectedClient.clientId)) {
          setViewedClientIds([...viewedClientIds, selectedClient.clientId]);
        }
      }
    }
  };

  return (
    <>
      <Box className="welcome-screen-single-client">
        <Box
          className="header"
          sx={{paddingBottom: showMetricsTileSection ? '48px' : '0px'}}
        >
          <AurBreadcrumb items={breadCrumbItems} />
          <Box className="action-icon-group">
            <AurTooltip
              title={t('welcomeScreenSingleClient.exportAsXlsx')}
              disableInteractive
              classes={tooltipClasses}
              slotProps={{
                popper: {
                  modifiers: [{name: 'offset', options: {offset: [0, -6]}}],
                },
              }}
            >
              <IconButton
                className="loading-export-icon export-icon-bg"
                onClick={handleDownloadProjectDetailsXlsx}
                disabled={isDownloadingCsv}
              >
                {isDownloadingCsv ? (
                  <AurLoadingIndicator size={19} />
                ) : (
                  <AurSvgIcon src="images/export_icon.svg" />
                )}
              </IconButton>
            </AurTooltip>
            {isMenuVisible && (
              <AurManageClientDropdown
                clientId={selectedClient?.clientId}
                showProjectSettings={hasProjectSettingsPermission}
              />
            )}
          </Box>
          <Box className="header-items">
            <Typography
              className="typo-text headline3_size first-text"
              data-testid="welcome-text"
              tabIndex={0}
            >
              {t('welcomeScreenSingleClient.welcomeBack')}
              {user?.givenname}
            </Typography>

            <Typography
              className="typo-text display1_size second-text"
              tabIndex={0}
            >
              {selectedClient.name}
            </Typography>

            {showMetricsTileSection && (
              <>
                <Box className="information">
                  <Box>
                    <Typography className="txt mist-700" tabIndex={0}>
                      {t(
                        'welcomeScreenSingleClient.cumulativeClientActivityInThe'
                      )}

                      <Typography className="typo-text label1_size mist-100 cumulative-client-info">
                        &nbsp;{t('clientInsights.last')} {dataSet?.recentDays}{' '}
                        {t('clientInsights.days')}
                      </Typography>
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      className="txt mist-700"
                      zIndex={100}
                      tabIndex={0}
                    >
                      {t('welcomeScreenSingleClient.metricsUpdatedAsOf')}

                      <Typography className="typo-text label1_size mist-100 cumulative-client-info">
                        &nbsp;{' '}
                        {dataSet ? (
                          <AurLightTooltip title={t('common.yearMonthDate')}>
                            <span>
                              {getUTCDateTimeForDisplay(
                                dataSet?.metricsUpdatedOn,
                                ONLY_DATE_SHOW_FORMAT
                              )}
                            </span>
                          </AurLightTooltip>
                        ) : (
                          'Loading...'
                        )}
                      </Typography>
                    </Typography>
                  </Box>
                </Box>
                <Box className="tiles">
                  <IconButton
                    className="tile-item"
                    data-testid="kpi-btn-1"
                    onClick={() => {
                      handleDrawer();
                      setTabValue(0);
                    }}
                  >
                    <Typography className="count" tabIndex={0}>
                      {formatNumberWithComma(dataSet?.projectsAdded)}
                    </Typography>
                    <Typography className="description" tabIndex={0}>
                      {t('welcomeScreenSingleClient.projectsAdded')}
                    </Typography>
                  </IconButton>
                  <div className="tile-item"></div>
                  <IconButton
                    className="tile-item"
                    data-testid="kpi-btn-2"
                    onClick={() => {
                      handleDrawer();
                      setTabValue(1);
                    }}
                  >
                    <Typography className="count" tabIndex={0}>
                      {formatNumberWithComma(dataSet?.datasetsProcessed)}
                    </Typography>
                    <Typography className="description" tabIndex={0}>
                      {t('welcomeScreenSingleClient.datasetsProcessed')}
                    </Typography>
                  </IconButton>
                  <div className="tile-item"></div>
                  <IconButton
                    className="tile-item"
                    data-testid="kpi-btn-3"
                    onClick={() => {
                      handleDrawer();
                      setTabValue(2);
                    }}
                  >
                    <Typography className="count" tabIndex={0}>
                      {formatNumberWithComma(dataSet?.productionCompleted)}
                    </Typography>
                    <Typography className="description" tabIndex={0}>
                      {t('welcomeScreenSingleClient.productionsCompleted')}
                    </Typography>
                  </IconButton>
                </Box>
              </>
            )}

            <Box className="custom_report-alert">
              {loadingAlert && (
                <Box className="loading-alert-container">
                  <AurLoadingIndicator show={loadingAlert} />
                </Box>
              )}
              {mergedAlertData?.length > 0 ? (
                <Box>
                  <Box className="custom_report-text-container">
                    <Typography
                      className="typo-text headline3_size"
                      tabIndex={0}
                    >
                      {t('welcomeScreenSingleClient.recentAlerts')}
                    </Typography>
                  </Box>
                  <AurAlertCarousel
                    alertsData={
                      mergedAlertData?.map((alert) => ({
                        ...alert,
                        deleteButtonHandler: () =>
                          markAlertAsViewed(alert.userAlertId),
                        showArrowCTA: true,
                        budgetDataLength: budgetDataLength,
                        prevButtonHandler: () => handleCustomRedirection(alert),
                        onPressNavigationHandler: () =>
                          onHandleNavigation(
                            budgetDataLength,
                            alert.projectName,
                            alert.projectId,
                            alert.userAlertId
                          ),
                      })) as []
                    }
                  />
                </Box>
              ) : null}
            </Box>
          </Box>

          <BackgroundImage className="background-image" aria-hidden="true"/>
        </Box>

        <Box className="single-client-content align-from-left">
          <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
            <Box className="processing-summary-and-exceptions-details">
              <div className="intake-audit-report-detail">
                <div className="processing-summary-description">
                  <Typography
                    className="typo-text subhead1_size mist-100 "
                    tabIndex={0}
                  >
                    {t('welcomeScreenSingleClient.filterLabel')}
                  </Typography>
                  {hasCreateProjectsPermission ? (
                    <AurButton
                      type="continue"
                      size="Medium"
                      startIcon={<PlusIcon aria-hidden />}
                      label={`${t('clientDetailsPage.projectTable.createNewProject')}`}
                      onClick={handleCreateNewProject}
                      dataTestId="aur-create-new-project-button"
                      ariaLabel={`${t('clientDetailsPage.projectTable.createNewProject')}`}
                    />
                  ) : null}
                </div>
                <div
                  style={{
                    display: 'flex',
                    padding: '0px 50px 0px 0px',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                    }}
                  >
                    <div
                      style={{
                        width: '260px',
                      }}
                    >
                      <AurSelectDropdown
                        sx={{
                          width: '260px',
                        }}
                        items={projectOverviewFilterOptions.branches ?? []}
                        searchPlaceHolder={t('filter.branch')}
                        itemsCountwithNoScroll={3}
                        onClearClicked={() => onRemoveFilter(1)}
                        itemDisplay="name"
                        itemKey="id"
                        selectAllLabel={t('filter.selectAll')}
                        dropdownLabel={t('filter.branch')}
                        onSelectionChange={(data) => {
                          const selectedItems = data?.map((item) => {
                            return {
                              id: item.id,
                              value: item.name,
                            };
                          });
                          setProjectOverviewSelectedFilterOptions((prev) => {
                            return {
                              ...prev,
                              branches: (data as any) ?? [],
                            };
                          });
                          handleOnDropdownDataChanged(0, selectedItems);
                        }}
                        hasValidationError={false}
                        validationText={t('validation.selectAtLeastOneProject')}
                        helperText=""
                        aria-label={t('aria.projectSelectCustodian')}
                        defaultSelection={chipConfigs[0]?.filterSelection?.map(
                          (item) => {
                            return {
                              id: item.id,
                              name: item.value,
                            };
                          }
                        )}
                      />
                    </div>
                    <div
                      style={{
                        width: '260px',
                      }}
                    >
                      <AurSelectDropdown
                        sx={{
                          width: '260px',
                        }}
                        items={projectOverviewFilterOptions.departments ?? []}
                        searchPlaceHolder={t('filter.filterdepartment')}
                        itemsCountwithNoScroll={3}
                        itemDisplay="name"
                        itemKey="id"
                        onClearClicked={() => onRemoveFilter(2)}
                        selectAllLabel={t('filter.selectAll')}
                        dropdownLabel={t('filter.filterdepartment')}
                        onSelectionChange={(data) => {
                          const selectedItems = data?.map((item) => {
                            return {
                              id: item.id,
                              value: item.name,
                            };
                          });
                          setProjectOverviewSelectedFilterOptions((prev) => {
                            return {
                              ...prev,
                              departments: (data as any) ?? [],
                            };
                          });
                          handleOnDropdownDataChanged(1, selectedItems);
                        }}
                        hasValidationError={false}
                        validationText={t('validation.selectAtLeastOneProject')}
                        helperText=""
                        aria-label={t('aria.projectSelectItemCategory')}
                        defaultSelection={chipConfigs[1]?.filterSelection?.map(
                          (item) => {
                            return {
                              id: item.id,
                              name: item.value,
                            };
                          }
                        )}
                      />
                    </div>
                    <div
                      style={{
                        width: '260px',
                      }}
                    >
                      <AurSelectDropdown
                        sx={{
                          width: '260px',
                        }}
                        items={projectOverviewFilterOptions.entities ?? []}
                        searchPlaceHolder={t('filter.entity')}
                        itemsCountwithNoScroll={3}
                        onClearClicked={() => onRemoveFilter(3)}
                        itemDisplay="name"
                        itemKey="id"
                        selectAllLabel={t('filter.selectAll')}
                        dropdownLabel={t('filter.entity')}
                        onSelectionChange={(data) => {
                          const selectedItems = data?.map((item) => {
                            return {
                              id: item.id,
                              value: item.name,
                            };
                          });
                          setProjectOverviewSelectedFilterOptions((prev) => {
                            return {
                              ...prev,
                              entities: (data as any) ?? [],
                            };
                          });
                          handleOnDropdownDataChanged(2, selectedItems);
                        }}
                        hasValidationError={false}
                        validationText={t('validation.selectAtLeastOneProject')}
                        helperText=""
                        aria-label={t('aria.projectSelectCustodian')}
                        defaultSelection={chipConfigs[2]?.filterSelection?.map(
                          (item) => {
                            return {
                              id: item.id,
                              name: item.value,
                            };
                          }
                        )}
                      />
                    </div>
                    <div
                      style={{
                        width: '3560px',
                      }}
                    ></div>
                    <div
                      style={{
                        width: '356px',
                      }}
                    >
                      <AurSearchBox
                        label={t('userHomePage.search')}
                        minCharForSearch={MIN_SEARCH_CHAR}
                        info={true}
                        value={searchKeyword}
                        classNameProps={'custom-text-field-filter search-box'}
                        onSearch={handleOnSearch}
                        arrowPosition="right"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      paddingTop: '22px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                    }}
                  >
                    {hasChipSelections && (
                      <div className="chip-container">
                        <AurChipList
                          onResetToDefault={handleResetToDefault}
                          onSave={handleOnSave}
                          onClearAll={handleOnClearAll}
                          hasFilterValueChanged={hasFilterValueChanged}
                          chipConfigs={chipConfigs}
                          isOnSaveLoading={isOnSaveFilterLoading}
                          isClearAllLoading={isClearAllFilterLoading}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Box>
            {isGetProjectsLoading && (
              <AurLoadingIndicator
                overlay={true}
                isOpen={isGetProjectsLoading}
              />
            )}

            <Tabs
              data-testid="Tabs"
              value={value}
              onChange={handleChange}
              aria-label={t('aria.basicTabsExample')}
              className="aur-tabs user-page-tabs"
            >
              <Tab
                data-testid="all"
                label={t('userHomePage.all') + ` (${memberStats.total})`}
                {...a11yProps(0)}
              />
              <Tab
                data-testid="active"
                label={t('userHomePage.active') + ` (${memberStats.active})`}
                {...a11yProps(1)}
              />
              <Tab
                data-testid="closed"
                label={t('userHomePage.closed') + ` (${memberStats.closed})`}
                {...a11yProps(2)}
              />
            </Tabs>
          </Box>
          {isFailedToLoadContent ? (
            <AurDataGridErrorOverlay
              onRefresh={() => refreshOverviewProjects()}
              containerHeight={size}
            />
          ) : (
            <>
              {projects && (
                <div
                  className="project-list-container"
                  id="project-list-container"
                >
                  {projects.map((project, index) => {
                    if ('isSeparator' in project) {
                      return (
                        <div
                          key={`${project.projectName}-${index}`}
                          style={{margin: '24px 0'}}
                        />
                      );
                    }

                    return (
                      <div
                        key={project.projectId}
                        ref={(el) =>
                          (listRefMap.current[project.projectName] = el)
                        }
                      >
                        <ProjectListItem
                          projectDetails={project}
                          clientId={selectedClient.clientId}
                          viewProjectName={viewProjectName}
                          refreshProjectList={refreshOverviewProjects}
                          expanded={expandedProjectId === project.projectId}
                          onToggle={() => {
                            setExpandedProjectId((prev) =>
                              prev === project.projectId
                                ? null
                                : project.projectId
                            );
                            onExpandProject(
                              project.domainCountryCode,
                              project.ecaEnabled
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        </Box>
        <>
          {totalItems > MIN_ITEMS_HIDE_PAGINATION && (
            <AurPagination
              itemType={t('common.projects')}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setItemsPerPage={handleItemsPerPageChange}
              onPageChange={handlePageChange}
            />
          )}
        </>
        {clearAllModal && (
          <AurPopup
            className="aur-unsaved-changes-popup"
            open={clearAllModal}
            onOk={handleClearAllModalOptionSelected}
            onCancel={closeModalHandler}
            popupTitle={t('common.clearAllPopup.popupTitle')}
            popupHeading={t('common.clearAllPopup.clearHeading')}
            popupContent={t('common.clearAllPopup.popupContent')}
            showPopupHeading={true}
            showPopupTitle={true}
            showCloseIcon={true}
            labelActionCancel={t('common.clearAllPopup.buttonCancel')}
            labelActionOk={t('common.clearAllPopup.buttonYes')}
          />
        )}
        {resetToDefaultModal && (
          <AurPopup
            className="aur-unsaved-changes-popup"
            open={resetToDefaultModal}
            onOk={handleResetToDefaultModalOptionSelected}
            onCancel={closeModalHandler}
            popupTitle={t('common.clearAllPopup.popupTitle')}
            popupHeading={t('common.clearAllPopup.ResetHeading')}
            popupContent={t('common.clearAllPopup.ResetDes')}
            showPopupHeading={true}
            showPopupTitle={true}
            showCloseIcon={true}
            labelActionCancel={t('common.clearAllPopup.buttonCancel')}
            labelActionOk={t('common.clearAllPopup.ResetYes')}
            exitButtonHint={t('common.clearAllPopup.cancelResetToDefaultHint')}
            continueButtonHint={t(
              'common.clearAllPopup.confirmResetToDefaultHint'
            )}
            cancelButtonTitle=""
          />
        )}
      </Box>
      {showBudgetTrackerModal ? <BudgetTrackerOverview /> : null}
      {showDrawer && (
        <KpiPanel
          setShowDrawer={setShowDrawer}
          tabValue={tabValue}
          setTabValue={setTabValue}
          showDrawer={showDrawer}
          dataSet={dataSet}
        />
      )}
      {showBudgetTrackerAlertModal ? <BudgetTrackerAlertModal /> : null}
      <AurToast
        ariaLabel={t('common.toastAlert.toastAlertHint')}
        hideDuration={5000}
        open={openToast}
        horizontalPosition={'center'}
        message={t(
          'ecaHomepageModals.budgetTracker.budgetTrackerOverview.deleteToastMessage'
        )}
        onClose={() => handleSnackbarClose}
      />
    </>
  );
};

export default WelcomeScreenSingleClient;
